import Swiper from "swiper";
import { A11y, Grid, Navigation, Pagination } from "swiper/modules";
import "@/styles/components/slider.css";

document.querySelectorAll(".element-benefits").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Grid, Navigation, Pagination],
    slidesPerView: 2,
    slidesPerGroup: 2,
    speed: 750,
    loop: true,
    pagination: {
      el: el.querySelector(".slider-pagination"),
      clickable: true,
    },
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        slidesPerGroup: 8,
        loop: false,
        grid: {
          fill: "row",
          rows: 2,
        },
      },
    },
  });
});
